import { Alert, AlertTitle } from '@mui/material';
import { ReactNode } from 'react';

interface ErrorMessageProps {
  title: string;
  message: string;
  icon: ReactNode;
  severity?: 'error' | 'warning' | 'info' | 'success';
}

function ErrorMessage({ title, message, icon, severity = 'error' }: ErrorMessageProps) {
  return (
    <Alert
      severity={severity}
      icon={icon}
      sx={{
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
      }}
    >
      <AlertTitle sx={{ fontWeight: 600 }}>{title}</AlertTitle>
      {message}
    </Alert>
  );
}

export default ErrorMessage;

